import Decimal from 'decimal.js';
import { z } from 'zod';
import { currencyCodes, type Currency } from '../locale/currencies';
import { impactShopCurrencyPricesSchema } from '../impact-products/impact-product-schemas';

export function calculateImpactFundUnitPrices(
  allocations: Array<{
    percentage: string | number;
    unitPrices: Record<Currency, string | number>;
  }>,
): z.infer<typeof impactShopCurrencyPricesSchema> {
  return Object.fromEntries(
    currencyCodes.map(currency => [
      currency,
      calculateWeightedImpactFundUnitPrice(
        allocations.map(allocation => ({
          percentage: allocation.percentage,
          unitPrice: allocation.unitPrices[currency],
        })),
      ).toNumber(),
    ]),
  ) as z.infer<typeof impactShopCurrencyPricesSchema>;
}

export function calculateWeightedImpactFundUnitPrice(
  allocations: Array<{ percentage: Decimal.Value; unitPrice: Decimal.Value }>,
): Decimal {
  return allocations
    .reduce(
      (sum, allocation) => sum.plus(new Decimal(allocation.percentage).times(allocation.unitPrice)),
      new Decimal(0),
    )
    .toDecimalPlaces(6);
}
